import Raven from "raven-js";
import configs from "./utils/configs";
import * as gtag from "./gtag";
import { classifyGlobalJourneyRoute } from "./global-journey-routes";
import { getCookie } from "./react-components/cookieUtils"; // Assuming cookieUtils is in react-components
import { getAuthHeaders } from "./utils/getToken";

const telemetryQueue = [];
let cookieConsentApproved = false;

// Placeholder function to check for tracking consent
function hasTrackingConsent() {
  const consentCookie = getCookie("cookie_consent_level");
  if (consentCookie) {
    try {
      const consentLevel = JSON.parse(decodeURIComponent(consentCookie));
      return consentLevel.tracking === true;
    } catch (e) {
      console.error("Error parsing cookie consent level:", e);
      return false;
    }
  }
  return false;
}

export default async function registerTelemetry(trackedPage, trackedTitle) {
  const sentryDsn = configs.SENTRY_DSN;
  const gaTrackingId = configs.GA_TRACKING_ID;
  const globalMeasurementId = configs.GA4_GLOBAL_MEASUREMENT_ID;

  if (sentryDsn && !Raven.isSetup()) {
    Raven.config(sentryDsn).install();
  }

  const hasConsent = cookieConsentApproved || hasTrackingConsent();

  if (gaTrackingId) {
    if (hasConsent) {
      gtag.initialize(gaTrackingId, trackedPage, trackedTitle);
    } else {
      telemetryQueue.push({ type: "product_page_view", trackedPage, trackedTitle });
    }
  }

  const globalDecision = classifyGlobalJourneyRoute(trackedPage);
  if (globalMeasurementId && globalDecision.track) {
    if (hasConsent) {
      gtag.sendGlobalJourneyPageView(globalMeasurementId, globalDecision, trackedPage);
    } else {
      telemetryQueue.push({ type: "global_page_view", globalDecision, trackedPage });
    }
  }
}

export function processQueuedTelemetry() {
  cookieConsentApproved = true;
  const gaTrackingId = configs.GA_TRACKING_ID;
  const globalMeasurementId = configs.GA4_GLOBAL_MEASUREMENT_ID;

  while (telemetryQueue.length > 0) {
    const telemetry = telemetryQueue.shift();
    if (telemetry.type === "global_page_view") {
      if (globalMeasurementId) {
        gtag.sendGlobalJourneyPageView(globalMeasurementId, telemetry.globalDecision, telemetry.trackedPage);
      }
    } else if (gaTrackingId) {
      const { trackedPage, trackedTitle } = telemetry;
      gtag.initialize(gaTrackingId, trackedPage, trackedTitle);
    }
  }
}

export async function registerUserAttendedThePresentation(user_id) {
  const url = configs["CUSTOM_API_URL"] + "/register-user-attended-presentation";

  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(await getAuthHeaders(url, "POST"))
    },
    body: JSON.stringify({
      user_id: user_id,
      url: window.location.pathname
    })
  }).catch(() => {});
}
